<template>
  <div v-if="canAccessPage">
    <div style="text-align: center" class="title justify-center">
      <p class="mb-0">{{ titulo }}</p>
    </div>
    <v-container fluid grid-list-md class="DashboardPendencias_Orcamento">
      <v-data-iterator
        :items="dados"
        :server-items-length="totalPage"
        :options.sync="pagination"
        :hide-default-footer="escondePaginacao"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
        }">
        <template v-slot:default="props">
          <v-row align="start" justify="center">
            <v-col
              cols="12"
              v-for="(item) in props.items"
              :key="item.idOrcamento">
              <v-hover>
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 5 : 1}`" class="Card_Pendencia fill-height">
                  <v-card-title class="Card_Title">
                    <v-container fluid>
                      <v-row justify="space-between">
                        <span>
                          {{ `${item.tipoVerba} :: ${item.orcamento}` }}
                        </span>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn text icon
                                  v-on="on"
                                  @click.native="abrirDetalhamento(item)">
                              <v-icon >info</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $tc('label.detalhe', 2) }}</span>
                        </v-tooltip>
                      </v-row>
                    </v-container>
                  </v-card-title>
                  <v-card-text class="Card_Content">
                    <v-container fluid>
                      <v-row justify="center" align="center">
                        <v-col cols="12" class="pa-0">
                          <span>{{ `${$tc('label.periodo', 1)}: ${item.dataInicio} - ${item.dataFim}` }}</span>
                        </v-col>
                        <v-col cols="12" md="7" class="pa-0">
                          <span>
                            {{ `${$t('label.valor_planejado')}: ${getMoney(item.vlrOrcamento)}` }}
                          </span>
                        </v-col>
                        <v-col cols="12" md="5">
                          <v-spacer></v-spacer>
                          <orcamento-botoes-fluxo
                            :key="item.id"
                            :idOrcamento="item.id"
                            :status="item.status"
                            @recarregar="buscarDados()"
                            :exibir-acompanhamento="false"/>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import {
  getMoney,
  getPercent,
} from '../../common/functions/helpers';
import OrcamentoBotoesFluxo from '../orcamento/OrcamentoBotoesFluxo';
import { pendenciasFluxoOrcamento } from '../../common/resources/workflow-orcamento';
import { generateComputed } from '../../common/functions/roles-computed-generator';

export default {
  name: 'dash-inicial-pendencias-orcamento',
  components: {
    OrcamentoBotoesFluxo,
  },
  props: {
    filtros: Object,
    dashFornecedor: {
      type: Boolean,
      default: false,
    },
    dashCliente: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  computed: {
    titulo() {
      if (this.title) {
        return this.title;
      }
      return this.$tc('title.pendencia_orcamento', 2);
    },
    ...generateComputed('ORC', [
      'canAccessPage',
    ]),
  },
  data() {
    return {
      dados: [],
      escondePaginacao: true,
      pagination: {
        itemsPerPage: 5,
      },
      totalPage: 0,
      filtrosAplicados: this.filtros,

      realizouPrimeiraBusca: false,
    };
  },
  watch: {
    filtros: {
      handler() {
        this.filtrosAplicados = this.filtros;
        this.buscarDados();
        setTimeout(() => {
          this.realizouPrimeiraBusca = true;
        });
      },
    },
    pagination: {
      handler() {
        if (this.realizouPrimeiraBusca) {
          this.buscarDados();
        }
      },
      deep: true,
    },
  },
  methods: {
    getMoney,
    getPercent,

    buscarDados() {
      const params = {
        ...this.filtrosAplicados,
        tamanhoPagina: this.pagination.itemsPerPage,
        numeroPagina: this.pagination.page,
      };

      pendenciasFluxoOrcamento(params, this.$resource)
        .then((res) => {
          const { data } = res;

          if (!data.resposta.length && this.pagination.page > 1) {
            this.pagination.page -= 1;
            this.buscarDados();
            return;
          }
          this.dados = data.resposta;
          this.totalPage = data.quantidadeRegistrosPagina;
          this.$emit('update:total-pendencias', this.totalPage);
          this.escondePaginacao = (this.totalPage / this.pagination.itemsPerPage) <= 1;
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    abrirDetalhamento(orcamento) {
      this.$router.push({ name: 'verOrcamento', params: { idOrcamento: orcamento.id, from: 'dashboard-inicial' } });
    },
  },
};
</script>
<style>
.DashboardPendencias_Orcamento {
  padding-top: 0px;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Title {
  padding: 7px 7px 0px 7px ;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Title span {
  font-weight: 700;
  margin: 0px;
  font-size: 16px;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Content {
  padding: 7px 7px 0px 7px ;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Content span {
  font-size: 14px;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Title button span i,
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Title span,
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Content span,
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Content button span i {
  color: rgba(0,0,0,.70) !important;
}
.DashboardPendencias_Orcamento .Card_Pendencia .Card_Actions {
  padding-top: 0px;
}
</style>
